import { iconArrowRight } from "../../assets/icons"
import { Button } from 'components/Button'
import { useHistory } from 'react-router'
import { useEffect, useState } from 'react'
import { BaseRoutes } from 'routes/BaseRoutes'
import { Badge } from 'components/Badge'
import { useAuth } from "hooks/useAuth"

interface userProps {
  userId: number,
  userName?: string,
  email?: string,
  roleName?: string
}

interface roleProps {
  roleId: number,
  roleName?: string,
  usersEmail: string[],
  actions?: JSX.Element[],
}

interface userRowProps {
  userId: number,
  roleName: string
  userName: string,
  email: string,
  actions: JSX.Element[],
}

interface roleRowProps {
  roleId: number,
  roleName: string,
  usersEmail: React.FC[],
  actions: JSX.Element[],
}

export const usePermissions = () => {
  const [loading, setLoading] = useState(true);
  const [hasUsersError, setHasUsersError] = useState(false);
  const [hasRolesError, setHasRolesError] = useState(false);
  const [userRows, setUserRows] = useState<userRowProps[]>();
  const [roleRows, setRoleRows] = useState<roleRowProps[]>();
  const history = useHistory();
  const { connectAllApi } = useAuth();
  var currentPage = 1;

  useEffect(() => {
    getData();
  }, []);

  const rowActionButton = (route: string) => {
    return (
      <Button 
        label="" 
        size="small" 
        icon={iconArrowRight} 
        onlyIcon={true} 
        onClick={() => push(route)} 
      />
    )
  }

  const getData = async () => {
    setLoading(true);
    connectAllApi([
      {type: 'get', url: `users?rowsPerPage=999&pageNumber=${currentPage}`},
      {type: 'get', url: 'users/roles'},
    ]).then((responses) => {
      if (responses[0].status !== "rejected") {
        let body = responses[0].value.data;
        setHasUsersError(false);
        setUserRows([
          ...body.map((item: userProps) => ({
            userId: item.userId,
            roleName: item.roleName ?? 'N/A',
            userName: item.userName ?? 'N/A',
            email: item.email ?? 'N/A',
            actions: [rowActionButton(BaseRoutes.userDetails.replaceAll(':id', item.userId.toString()))],
          })),
        ]);
      } else {
        setHasUsersError(true);
      }
      if (responses[1].status !== "rejected") {
        setHasRolesError(false);
        setRoleRows([
          ...responses[1].value.data.map((item: roleProps) => ({
            roleId: item.roleId,
            roleName: item.roleName,
            usersEmail: item.usersEmail.slice(0, 3).map((email, index) => {
              if (index < 2)
                return <Badge fontSize={14} fontWeight={500} value={email}/>
              else if (item.usersEmail.length > 2)
                return <Badge fontSize={14} fontWeight={500} value={`+${item.usersEmail.length-2}`}/>
            }),
            actions: [rowActionButton(BaseRoutes.roleDetails.replaceAll(':id', item.roleId.toString()))],
          })),
        ]);
      } else {
        setHasRolesError(true);
      }
    }).catch((_) => {
      setHasUsersError(true);
      setHasRolesError(true);
    }).finally(() => setLoading(false));
  }
  

  const push = (route: string): void => {
    history.push(route);
  }

  return {userRows, roleRows, push, loading, hasUsersError, hasRolesError};
}